import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_OFFER1_80: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_OFFER1_80,
  },
  {
    pageId: PageId.CHAT_UPSELL_OFFER1_80,
  },
  {
    pageId: PageId.UPSELL_OFFER1_80,
  },
  {
    pageId: PageId.DOWNLOAD_OFFER1_80,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
